import { HostProductCodeDtoToEntity } from "src/app/features/HostProductCode/services/mappers/HostProductCodeDtoToEntity";
import type { HostProductCodeDto } from "src/app/features/HostProductCode/types/HostProductCodeDto";
import type { HostProductCodeEntity } from "src/app/features/HostProductCode/types/HostProductCodeEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const HostProductCodeTableDtoMapper = (
    input: Readonly<ResourcePageDto<HostProductCodeDto>>,
): ResourcePageEntity<HostProductCodeEntity> => {
    return {
        list: input.list ? input.list.map(HostProductCodeDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
